import { PivotEntity, RawPivot } from './Types';
import { BaseModel } from '../BaseModel/BaseModel';

export class PivotModel extends BaseModel<RawPivot, PivotEntity> implements PivotEntity {
    createdAt: string = new Date().toISOString();
    projectId: number = 0;
    updatedAt: string = new Date().toISOString();
    userId: number = 0;

    constructor(pivot?: RawPivot) {
        super();
        if (pivot) {
            this.initialize(pivot);
        }
    }

    initialize(pivot: RawPivot) {
        this.createdAt = pivot.created_at;
        this.projectId = pivot.project_id;
        this.updatedAt = pivot.updated_at;
        this.userId = pivot.user_id;
    }

    parse(): RawPivot {
        return {
            created_at: this.createdAt,
            updated_at: this.updatedAt,
            project_id: this.projectId,
            user_id: this.userId,
        }
    }
}